<template>
  <ul class="answers" :class="{ 'multiple' : multiselect }">
    <li v-for="(answer, index) in answers" :class="{ 'correct-answer' : answer.correct }" :key="`content-${index}`">
      <input v-if="multiselect" type="checkbox" >
      <input v-else type="radio" >
      <label>{{ answer.content }}</label>
    </li>
  </ul>
</template>
<script>
export default {
  props: {
    answers: {
      type: Array,
      required: true
    },
    multiselect: {
      type: Boolean
    }
  }
}
</script>
